import type { CpmState } from '../../../types/centralProductMaster.types';

type StateRow = Pick<CpmState, 'name'> & { state?: string };

export function catalogStateName(row: StateRow | string | null | undefined): string {
    if (row == null) return '';
    if (typeof row === 'string') return row.trim();
    return String(row.name ?? row.state ?? '').trim();
}

export function toStateFilterOptions(
    rows: ReadonlyArray<StateRow> | undefined
): { value: string; label: string }[] {
    const seen = new Set<string>();
    const options: { value: string; label: string }[] = [];
    for (const row of rows ?? []) {
        const name = catalogStateName(row);
        if (!name || seen.has(name)) continue;
        seen.add(name);
        options.push({ value: name, label: name });
    }
    return options;
}
